import { render } from "./ApiMonitor.vue?vue&type=template&id=4074b0e9&scoped=true"
import script from "./ApiMonitor.vue?vue&type=script&lang=js"
export * from "./ApiMonitor.vue?vue&type=script&lang=js"

import "./ApiMonitor.vue?vue&type=style&index=0&id=4074b0e9&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4074b0e9"]])

export default __exports__